import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Breadcrumb } from 'types/breadcrumb.interface';

@Component({
  selector: 'app-breadcrumbs',
  standalone: true,
  imports: [TranslateModule, NgIf],
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss'
})
export class BreadcrumbsComponent {
  @Input() breadcrumbs!: Breadcrumb[];
}
